const configuration = {
  config: {
    client_id: "spaCodeClient",
    redirect_uri: window._env_.REACT_APP_URL + "/callback",
    response_type: "code",
    post_logout_redirect_uri:  `${window._env_.REACT_APP_URL}/landingpage`,
    scope: "openid",
    authority: window._env_.REACT_APP_IDP_URL,
    silent_redirect_uri: window._env_.REACT_APP_URL + "/silent_callback",
    automaticSilentRenew: true,
    loadUserInfo: true,
    monitorSession: false,
  }
};

export default configuration;
